export default __webpack_public_path__ + "static/media/LENS_CULINARIS_TEKAY_complete_2.26e218f6.jpg";